import { lazy, Suspense } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import ErrorBoundary from "../components/ErrorBoundary"; // Make sure to create this component
import Loader from "../components/Loader"; 


const ArchiveList = lazy(() => import("../pages/contentplan/ContentList"));
const ArchiveEdit = lazy(() => import("../pages/contentplan/ContentEdit"));
const ContentPlanEdit = lazy(() => import("../pages/contentplan/ContentEditPlan"));
const ArchiveAdd = lazy(() => import("../pages/contentplan/ContentAdd"));
const ContentPlanEditM2 = lazy(() => import("../pages/contentplan/ContentEditPlan-m2"));
const ContentPlanEditM3 = lazy(() => import("../pages/contentplan/ContentEditPlan-m3"));
const ContentPlanEditCD = lazy(() => import("../pages/contentplan/ContentEditPlanCD"));
const ContentPlanConsumer1 = lazy(() => import("../pages/contentplan/ContentEditPlan-consumer1"));
const ContentPlanConsumer2 = lazy(() => import("../pages/contentplan/ContentEditPlan-consumer2"));
const ContentPlanConsumer3 = lazy(() => import("../pages/contentplan/ContentEditPlan-consumer3"));
const ContentPlanConsumer4 = lazy(() => import("../pages/contentplan/ContentEditPlan-consumer4"));


const routesForm = [
  {
    path: "*",
    element: (
      <Navigate to="/contentplan" />
    ),
  },
  {
    path: "/contentplan",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <ArchiveList />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/contentplan/edit-contentplan0",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
           <ArchiveEdit /> 
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/contentplan/add-contentplan",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
         <ArchiveAdd/> 
        </Suspense>
      </ErrorBoundary>
    ),
  },
 
  {
    path: "/contentplan/edit-contentplan",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
         <ContentPlanEdit/> 
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/contentplan/edit-contentplan1",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
        <ContentPlanConsumer1/> 
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/contentplan/edit-contentplan2",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
        <ContentPlanConsumer2/>  
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/contentplan/edit-contentplan3",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
         <ContentPlanConsumer3/> 
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/contentplan/edit-contentplan4",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
         <ContentPlanConsumer4/> 
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/contentplan/edit-contentplan5",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
        <ContentPlanEditCD/> 
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/contentplan/edit-contentplan6",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
        <ContentPlanEditCD/>  
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/contentplan/edit-contentplan7",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
         <ContentPlanEditM2/> 
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/contentplan/edit-contentplan8",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
         <ContentPlanEditM3/> 
        </Suspense>
      </ErrorBoundary>
    ),
  },
];

const Router = createBrowserRouter(routesForm);

export { Router };